import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../services/message-observable.service';
import { DLiquidacionRecibo, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { DSugeridaNubeServicios, DResponseNube, DInfoSugeridaNubeNoExperto, RESPONSE_EXAMPLE_AZURE } from '@dian-api/sugerida-nube';
import { SelectTabOption } from '../../tab/tab.component';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { SugeridaSingletonService } from '../../../services/sugerida.service';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DContextoMuisca } from '@dian/core';
import { DRenta210v18Servicios } from '@dian-api/renta210v18';
import { DDilPersonaRutJSON } from '@dian-api/devoluciones';

interface InfoPago {
  liquidacion: DLiquidacionRecibo,
  reciboPago: DRtaLiquidacionReciboPago
}

@Component({
  selector: 'app-contenedor-formulario-no-experto',
  templateUrl: './contenedor-formulario.component.html',
  styleUrls: ['./contenedor-formulario.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ DNotificacionServicio, DSugeridaNubeServicios, DRenta210v18Servicios ]
})
export class ContenedorFormularioComponent implements OnInit {

  @ViewChild('scrollContainerForm') scrollContainerForm: ElementRef;

  public optionsTabs: any[] = [];
  public indexSelectedTab: number = 1;
  public loading: boolean = true;
  public showHelp: boolean = false;
  public helpTitle: string = '';
  public helpText: string = '';
  public showBtnDeclaSug: boolean = false;
  public showSaveButton: boolean = false;
  public dataForm: DDatosCompartidosCabecera = new DDatosCompartidosCabecera();
  public infoPago: InfoPago;
  public showDataReciboPago: boolean = false;
  public fechaPago: Date = new Date();
  public guardadoReciboPago: boolean = false;
  public listCuotas: Array<number> = new Array<number>();
  public higlightHelp: boolean = true;
  public disabledDatePago: boolean = false;
  scrollTopPosition: number = 0;

  private stepsHideSaveButton = [13];

  constructor(
    private _messagesObs: MessageObservableService,
    private _sugeridaSingletonService: SugeridaSingletonService,
    private dContextoUsuario: DContextoUsuarioServicio,
    private _sugeridaNubeService: DSugeridaNubeServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private dServicioRESTAPI: DRenta210v18Servicios
  ) { }

  ngOnInit(): void {
    this.listenMessagesObs();
    this.listenScrollFormEvent();
    
    this.dContextoUsuario.consultarContextoUsuarioMuisca().subscribe(
      (res: DContextoMuisca) => {
        const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
        if (!contexto) {
          this.dNotificacionServicio.mostrarDialogoError("Error obteniendo el contexto para la declaración sugerida desde nube");
          return;
        }
       
        this._sugeridaNubeService.initialize(contexto.token.idToken, contexto.token.clientId);
        const nitenviado=contexto.ANombrePropio ? ""+contexto.NitUsuario : ""+contexto.NitOrganizacion;
        this.dServicioRESTAPI.consultarNit(nitenviado).subscribe(
          (data: DDilPersonaRutJSON) => this.getAndSaveDataSugerida(Number(data.codigoPersonaMas),
          this.dataForm.anio,this.dataForm.periodo,this.dataForm.periodicidad),//res.tipoDocumento, res.NitUsuario
          error => console.log(error)
        );        
      }
    );  
  }

  private listenScrollFormEvent() {
    fromEvent(this.scrollContainerForm.nativeElement, 'scroll')
      .subscribe((e: Event) => this.scrollTopPosition = e.target['scrollTop']);
  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'init-tabs') {
        this.optionsTabs = res.message.tabs;
        this.indexSelectedTab = res.message.index;
      }

      if (res.operation === 'info-form') {
        this.dataForm = res.message;
        this.loading = false;
      }

      if (res.operation === 'help') {
        this.helpTitle = res.message.title;
        this.helpText = res.message.text;
        this.showHelp = true;
        this.higlightHelp = true;

        setTimeout(() => this.higlightHelp = false, 3000);
      }

      if (res.operation === 'show-declasug')
        this.showBtnDeclaSug = true;

      if (res.operation === 'index-tab-stepper') {
        if (res.message.tab === 0) this.showSaveButton = false;
        else {
          if (this.stepsHideSaveButton.indexOf(res.message.stepper) > -1)
            this.showSaveButton = false;
          else this.showSaveButton = true;
        }
      }

      if (res.operation === 'recibo-pago-visualizar') {
        this.infoPago = res.message;
        this.showDataReciboPago = true;
      }

      if (res.operation === 'recibo-pago-guardado')
        this.guardadoReciboPago = res.message;

      if (res.operation === 'lista-cuotas-recibo-pago')
        this.listCuotas = res.message;

      if (res.operation === '490-position-tab')
        this.disabledDatePago = res.message > 0;

      if (res.operation === 'scroll-to-top') {
        //this.scrollContainerForm.nativeElement.scrollIntoView({ behavior: 'smooth' });
        this.scrollContainerForm.nativeElement.scrollTo({ left: 0, top: 0 });
      }

      if (res.operation === 'move-scroll') {
        this.scrollTopPosition += this.scrollTopPosition + res.message;
        // this.scrollContainerForm.nativeElement.scrollTo({ left: 0, top: this.scrollTopPosition });
      }

      if (res.operation === 'index-selected') {
        this.indexSelectedTab = res.message;
      }
    });
  }

  showDeclaSug() {
    //this._messagesObs.sendMessages('open-decla-sug', true);
    window.location.href = window.location.origin + '/WebDilIngresoFormRenta210/#/ingreso?idRequest=c3VnZXJpZGE9MjAyMg%3D%3D';
  }

  saveForm() {
    this._messagesObs.sendMessages('save-form', true);
  }

  calcularInteresRecibo() {
    this._messagesObs.sendMessages('calcular-intereses', true);
  }

  changeFechaPago() {
    this._messagesObs.sendMessages('change-fechapago', this.fechaPago);
  }

  clearMessage() {
    this.showHelp = false;
    this.helpTitle = '';
    this.helpText = '';
  }

  onSelectTab(model: SelectTabOption) {
    this._messagesObs.sendMessages('change-tab', model);
  }

  private getAndSaveDataSugerida(idPersonaRUT: number, anioDeclaracion: number, periodo:number,periodicidad:string) {//tipoDocumento: string, numDocumento: string
  //  if (window.location.origin.includes('localhost')) {
     // const dataExample: DInfoSugeridaNubeNoExperto[] = RESPONSE_EXAMPLE_AZURE;
    //  this._sugeridaSingletonService.arrToMap(dataExample);
    //  return;
   // }
   
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._sugeridaNubeService.obtenerSugeridaNubeNoExperto(idPersonaRUT,anioDeclaracion,periodo,periodicidad).subscribe(//tipoDocumento, numDocumento
      (res: DResponseNube) => {        
        const dataSugeridaNube = <DInfoSugeridaNubeNoExperto[]>res.data;
        this._sugeridaSingletonService.arrToMap(dataSugeridaNube);                
        preloader.close();
        this.dNotificacionServicio.mostrarDialogoConfirmacion('<p><b>La DIAN, con el ánimo de facilitar el proceso de preparación de la declaración de renta a personas naturales</b>, ha diseñado un sistema de diligenciamiento basado en una serie de preguntas que le guiarán en la presentación, acompañado de información sugerida obtenida de la información exógena y de facturación electrónica reportada por terceros correspondiente al <b>año gravable 2023</b>.</p><p>Es su responsabilidad revisarla en detalle y realizar las modificaciones necesarias para que corresponda con su realidad jurídica, económica y financiera.</p>');

      },
      error => {
        preloader.close();
       // this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la declaración sugerida desde nube");
      }
    );

    //Como invocar los datos de la sugerida
    //const fieldsRecovery = ['VAR_4049', 'VAR_4050', 'VAR_4051', 'VAR_4052', 'VAR_4060'];
    //const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
    //console.log(resData);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/contenedor-formulario/contenedor-formulario.component.ts